import React from 'react';
import Image from 'next/image';
import { Block, BLOCKS, INLINES, Inline } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import { Flexbox } from '../Flexbox';
import { Column } from '../Layout';
import RichText from '../RichText';
import { EmbeddedInlineEntryNode } from '../RichText/Nodes';

import {
  InlineAnchor,
  PrivacyPolicyWrapper,
  ParagraphWithLineBreaks
} from './styles';

import shield from '@/images/shield.svg';

type PrivacyPolicyDisclaimerProps = Pick<
  IFullwidthHero20Fields,
  'privacyPolicyDisclaimer' | 'displayPrivacyPolicyIcon'
>;

export default function PrivacyPolicyDisclaimer({
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon
}: PrivacyPolicyDisclaimerProps) {
  const RICH_TEXT_OVERRIDE: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
      return (
        <ParagraphWithLineBreaks
          as="p"
          fontSize={{
            0: '2xs',
            tablet: 's'
          }}
          fontWeight="400"
          colour="defaultText"
          textAlign={displayPrivacyPolicyIcon !== false ? 'left' : 'center'}
          marginLeft={displayPrivacyPolicyIcon !== false ? 'm' : 0}
        >
          {children}
        </ParagraphWithLineBreaks>
      );
    },
    [INLINES.HYPERLINK]: (node, children) => (
      <InlineAnchor
        href={node.data.uri}
        colour="defaultText"
        hoverColor="inlineAnchor"
      >
        {children}
      </InlineAnchor>
    ),
    [INLINES.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedInlineEntryNode node={node} colour="defaultText" fontWeight="p">
        {children}
      </EmbeddedInlineEntryNode>
    )
  };

  return (
    <Column size={12} margin={{ 0: 'auto', tablet: 0 }}>
      <Flexbox
        flexDirection="row"
        justifyContent="space-between"
        margin={{ 0: 'auto', tablet: 0 }}
        alignItems="center"
      >
        {/* If displayPrivacyPolicyIcon isn't set then we want to default to displaying the icon */}
        {displayPrivacyPolicyIcon !== false && (
          <Image alt="shield-icon" src={shield} />
        )}
        <PrivacyPolicyWrapper>
          <RichText
            data={privacyPolicyDisclaimer}
            overrideOptions={RICH_TEXT_OVERRIDE}
          />
        </PrivacyPolicyWrapper>
      </Flexbox>
    </Column>
  );
}
